import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import Image from '../../../../../../../atoms/Image';
import TextOverflow from '../../../../../../../modules/foundation/components/TextOverflow';
import { CurrencyNumberPropType, ImagePropType } from '../../../../../../../services/proptypes';
import { formatCurrency } from '../../../../../../../utils/currency';
import './CartItemDescription.css';
var defaultProps = {
  photo: null,
  itemDescription: '',
  itemInstructions: '',
  itemModifiers: ''
};
function CartItemDescription(_ref) {
  var photo = _ref.photo,
    name = _ref.name,
    itemDescription = _ref.itemDescription,
    itemInstructions = _ref.itemInstructions,
    itemModifiers = _ref.itemModifiers,
    price = _ref.price;
  return /*#__PURE__*/React.createElement(Grid.Row, {
    className: "cart-item-description"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    width: 2,
    floated: "left",
    className: "cart-item-column"
  }, !_isEmpty(photo) && /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "cart-item-photo",
    src: photo
  }))), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 12,
    className: "cart-item-name-column"
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h4",
    className: "cart-item-name"
  }, name), itemDescription && /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, itemDescription), itemModifiers && /*#__PURE__*/React.createElement("div", {
    className: "modifiers"
  }, itemModifiers), itemInstructions && /*#__PURE__*/React.createElement(TextOverflow, {
    content: itemInstructions,
    className: "cart-item-name-instructions"
  })), /*#__PURE__*/React.createElement(Grid.Column, {
    width: 2,
    className: "cart-item-column cart-item-price",
    textAlign: "right"
  }, formatCurrency(price)));
}
CartItemDescription.defaultProps = defaultProps;
export default CartItemDescription;